import { useId, useRef } from 'react';
import { useAudioVolume } from 'features/VolumeIndicator/hooks/useAudioVolume';
import { WaveOverlay, WaveGroup, WavePath } from './view';

interface Props {
    size?: number;
}

/**
 * Накладывается поверх <Icon icMicrophoneOn>. Сам ничего из иконки не рисует —
 * только wave-fill, обрезанный маской по форме того же спрайтового символа.
 *
 * Уровень громкости приходит через imperative-коллбэк useAudioVolume и сразу
 * пишется в CSS-переменную `--volume` на корневом узле через ref. Компонент
 * НЕ ререндерится на изменения уровня — анимация волны крутится только CSS на GPU.
 */
export const MicrophoneWaveOverlay = ({ size = 24 }: Props) => {
    const maskId = useId();
    const ref = useRef<HTMLDivElement | null>(null);

    useAudioVolume({
        onLevelChange: (level) => {
            const clamped = Math.max(0, Math.min(1, level));
            ref.current?.style.setProperty('--volume', String(clamped));
        },
    });

    return (
        <WaveOverlay ref={ref} style={{ width: size, height: size }}>
            <svg width={size} height={size} viewBox="0 0 24 24">
                <defs>
                    <mask id={maskId} maskUnits="userSpaceOnUse">
                        <rect width="24" height="24" fill="black" />
                        <use href="#icMicrophoneOn" fill="white" />
                    </mask>
                </defs>
                <g mask={`url(#${maskId})`}>
                    <WaveGroup>
                        <WavePath d="M-6,4 q3,-4 6,0 t6,0 t6,0 t6,0 t6,0 t6,0 L30,30 L-6,30 Z" />
                        <WavePath d="M-6,4 q3,-4 6,0 t6,0 t6,0 t6,0 t6,0 t6,0 L30,30 L-6,30 Z" data-back />
                    </WaveGroup>
                </g>
            </svg>
        </WaveOverlay>
    );
};

MicrophoneWaveOverlay.displayName = 'MicrophoneWaveOverlay';
